import styled, { css } from "styled-components";
import type { ComboBackgroundStyledProps } from "../types";

const afterStyles = ({
  $backgroundColor,
  $overlayOpacity,
}: ComboBackgroundStyledProps) => css`
  ${$backgroundColor && `background: ${$backgroundColor};`}
  opacity: ${$overlayOpacity ? Number($overlayOpacity) / 100 : 0};
`;

export const ComboBackgroundStyled = styled.div<ComboBackgroundStyledProps>`
  &::after {
    ${(props) => afterStyles(props)}
  }
`;
